import { gql } from '@apollo/client';

const trimDetail = {
  GET_TRIM_DETAIL: gql`
    query GetTrimDetail(
      $trimCode: TrimCode!
      $modelCode: String
      $engineCode: String
      $specPackCode: String
      $bodyStyleCode: String
    ) {
      trim(trimCode: $trimCode) {
        attributes {
          marketingprefix
          label
        }
      }
      model(id: $modelCode) {
        attributes {
          shortname
        }
      }
      engine(id: $engineCode) {
        attributes {
          shortname
        }
      }
      specPack(id: $specPackCode) {
        attributes {
          shortname
        }
      }
      bodyStyle(id: $bodyStyleCode) {
        attributes {
          shortname
        }
      }
    }
  `,
};

export default trimDetail;
